import { Link } from 'react-router-dom';
import { House } from 'lucide-react';

/** The portal home (V2 D88): top left of every screen outside the home. */
export function HomeButton({ dark = false }: { dark?: boolean }) {
  return (
    <Link
      to="/"
      title="Portal home"
      className={`inline-flex shrink-0 items-center gap-1.5 rounded-md px-2 py-1.5 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-gold ${dark ? 'text-white/85 hover:bg-white/10 hover:text-white' : 'text-ink hover:bg-band'}`}
    >
      <House size={16} />
      <span>Home</span>
    </Link>
  );
}
